// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function BandaidsIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m23.071 16 3.464-3.465a4.997 4.997 0 0 0 .062-7.132 5 5 0 0 0-7.132.062L16 8.929l-3.465-3.464a4.999 4.999 0 1 0-7.07 7.07L8.929 16l-3.464 3.465a5 5 0 1 0 7.07 7.07L16 23.071l3.465 3.464a5 5 0 1 0 7.07-7.07L23.07 16Zm-2.196-9.125a3.006 3.006 0 0 1 4.25 4.25L21.66 14.59l-4.246-4.246 3.46-3.469ZM20.239 16l-4.24 4.242L11.758 16 16 11.758 20.239 16ZM6.875 11.125a3.004 3.004 0 1 1 4.25-4.25l3.465 3.465-4.246 4.246-3.47-3.461Zm4.25 14a3.005 3.005 0 1 1-4.25-4.25l3.465-3.465 4.242 4.242-3.457 3.473Zm14 0a3 3 0 0 1-4.25 0L17.41 21.66l4.242-4.242 3.473 3.457a3 3 0 0 1 0 4.25ZM14.5 16a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
